@let asset = asset$ | async;

<loren-page-content>
    <mat-card class="loren-asset-form-steps mat-elevation-z0">
        <loren-asset-image-uploader (imageSelected)="selectedImage.set($event)"
                                    [entityImage]="$safeNavigationMigration(asset?.image) | lorenImage | async"
                                    look="mat-elevation-z0"/>
        <mat-stepper orientation="vertical" [linear]="true">
            <mat-step [stepControl]="basic" [label]='"asset.enter_common_properties_step" | transloco'>
                <form [formGroup]="basic">
                    <mat-form-field class="loren-form-field">
                        <mat-label>{{ "asset.name_property" | transloco }}</mat-label>
                        <input matInput formControlName="name"/>
                        @if (!basic.controls.name.valid) {
                            <mat-error>{{ "errors.field_required" | transloco }}</mat-error>
                        }
                    </mat-form-field>
                    @let assetTypes = assetTypes$ | async;
                    @if (assetTypes) {
                        <mat-form-field class="loren-form-field">
                            <mat-label>{{ "asset.type_property" | transloco }}</mat-label>
                            <mat-select formControlName="type">
                                @for (option of assetTypes; track option.id) {
                                    <mat-option [value]="option.id">
                                        {{ option.label | transloco }}
                                    </mat-option>
                                }
                            </mat-select>
                            @if (!basic.controls.type.valid) {
                                <mat-error>{{ "errors.field_required" | transloco }}</mat-error>
                            }
                        </mat-form-field>
                    }
                    <loren-hierarchy-autocomplete-field formControlName="groups"/>
                    <mat-form-field class="loren-form-field">
                        <mat-label>{{ "asset.description_property" | transloco }}</mat-label>
                        <textarea formControlName="description" matInput></textarea>
                    </mat-form-field>
                    <asset-location-selection formControlName="defaultLocation"/>
                    <div class="loren-asset-form-step-button">
                        <button mat-button matStepperNext color="primary">
                            {{ "operations.next" | transloco }}
                        </button>
                    </div>
                </form>
            </mat-step>

            <mat-step>
                <form [formGroup]="properties">
                    <ng-template matStepLabel>{{ "asset.enter_asset_custom_properties_step" | transloco }}</ng-template>
                    @let labels = propertyLabelMap$ | async;
                    @if (labels) {
                        @for (property of properties.controls | keyvalue; track property.key) {
                            <mat-form-field class="loren-form-field">
                                <mat-label>{{ labels.get(+property.key) | transloco }}</mat-label>
                                <input matInput [formControlName]="property.key"/>
                            </mat-form-field>
                        }
                    }
                    <div class="loren-asset-form-step-buttons">
                        <button mat-button matStepperPrevious>{{ "operations.back" | transloco }}</button>
                        <button mat-button matStepperNext color="primary">{{ "operations.next" | transloco }}</button>
                    </div>
                </form>
            </mat-step>

            <mat-step>
                <ng-template matStepLabel>{{ "asset.associate_sensor_to_metering" | transloco }}</ng-template>
                <div cdkDropList class="sensor-list" (cdkDropListDropped)="drop($event)"
                     [cdkDropListAutoScrollStep]="100">
                    @let sensorList = this.sensorsDrag$ | async;

                    @for (item of sensorList; track item; let idx = $index; ) {
                        @let sensor = this.sensors.at(idx);

                        <drag-item cdkDrag cdkDragLockAxis="y">
                            <div class="sensor-list-title">
                                {{ item.deviceName ?? ('device.unknown' | transloco) }} » {{ (item.sensorTranslationKey ?? 'asset.unknown_sensor') | transloco }}
                            </div>
                            @if (item.meteringContext) {
                                <div>
                                    <small>{{ METERING_CONTEXT_TRANSLATION_NAMES.get(item.meteringContext) | transloco }}</small>
                                </div>
                            }

                            <div><small>{{ item.description }}</small></div>
                            <ng-container actions>
                                @if (sensor.invalid) {
                                    <mat-icon class="icon-error" [matTooltip]="'asset.invalid_sensor_entry' | transloco">error</mat-icon>
                                }
                                <button unstyled-button (click)="handleDeleteSensor(idx)" type='button'
                                        [matTooltip]="'operations.delete' | transloco">
                                    <mat-icon color="warn">delete</mat-icon>
                                </button>
                                <button unstyled-button (click)="editSensor(idx)" type='button'
                                        [matTooltip]="'operations.edit' | transloco">
                                    <mat-icon color="primary">edit</mat-icon>
                                </button>
                            </ng-container>
                        </drag-item>
                    }
                </div>
                <div class="w-100 border-bottom mt-1 pb-5">
                    @if(this.sensors.hasError('minArrayLength')) {
                        <mat-error>{{ 'asset.error.at_least_one_sensor' | transloco }}</mat-error>
                    }
                    <button mat-button (click)="addSensor()" color="accent" type="button">
                        <mat-icon color="accent">add_circle</mat-icon>
                        {{ 'asset.add_sensor' | transloco }}
                    </button>
                </div>

                <div class="loren-asset-form-step-buttons mt-4">
                    <button mat-button matStepperPrevious>{{ "operations.back" | transloco }}</button>
                    <button
                            *lorenShowForPrivileges="[privileges.WRITE_ASSET]"
                            mat-stroked-button
                            matStepperNext
                            color="primary"
                            (click)="handleSubmitForm()"
                    >
                        {{ "operations.save" | transloco }}
                    </button>
                </div>
            </mat-step>
        </mat-stepper>
    </mat-card>
</loren-page-content>